export const brandSettings = {
  hasCurbside: false,
  hasShipping: true,
  hasDelivery: true,
  hasProductRatings: false,
  hasProductSearch: false,
}  as const;
